import { Decoration, Lockup } from '@superhi/design'
import React from 'react'

import { Wrapper } from '../Loading/styles'

type Props = {
  hAlign?: 'center' | 'left'
  noPadding?: boolean
  children?: string
  subtitle?: string
}

const NoResults: React.FC<React.PropsWithChildren<Props>> = ({
  noPadding = false,
  hAlign = 'center',
  children = 'No results',
  subtitle,
}) => (
  <Wrapper $noPadding={noPadding} $hAlign={hAlign}>
    <Decoration name="triangle" />
    <Lockup
      level="5"
      titleColor="GREY_90"
      title={children}
      titleMaxWidth={18}
      subtitle={subtitle}
    />
  </Wrapper>
)

export default NoResults
